import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function getLeadsCalls(uname, token) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getLeadsCalls.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        try {
          const rawData = body.toString();

          // Log per debugging
          console.log("getLeadsCalls - Raw response length:", rawData.length);

          // Prova prima senza unescape (per compatibilità con backend che gestisce già l'encoding)
          let resp;
          try {
            resp = JSON.parse(rawData);
            console.log(
              "getLeadsCalls - JSON parsato con successo senza unescape"
            );
          } catch (parseError) {
            console.log(
              "getLeadsCalls - Parsing diretto fallito, provo con unescapeStringNew"
            );
            // Se fallisce, prova con unescapeStringNew
            const unescapedData = Utils.unescapeStringNew(rawData);
            resp = JSON.parse(unescapedData);
            console.log(
              "getLeadsCalls - JSON parsato con successo con unescapeStringNew"
            );
          }

          resolve(resp);
        } catch (error) {
          console.error("Errore nel parsing JSON in getLeadsCalls:", error);
          console.error("Posizione errore:", error.message);

          // Tenta di riparare il JSON usando il vecchio metodo di unescape
          try {
            const rawData = body.toString();
            let cleanedData = Utils.unescapeString(rawData);

            // Rimuovi caratteri di controllo problematici
            cleanedData = cleanedData.replace(/[\x00-\x1F\x7F-\x9F]/g, "");

            // Tenta di trovare e correggere virgole doppie o errori comuni
            cleanedData = cleanedData.replace(/,\s*,/g, ",");
            cleanedData = cleanedData.replace(/,\s*}/g, "}");
            cleanedData = cleanedData.replace(/,\s*]/g, "]");

            const resp = JSON.parse(cleanedData);
            console.log("JSON riparato con successo");
            resolve(resp);
          } catch (secondError) {
            console.error("Impossibile riparare il JSON:", secondError);

            // Ultimo tentativo: prova senza fare alcun unescape
            try {
              const rawData = body.toString();

              // Prova a parsare direttamente il JSON senza unescape
              const resp = JSON.parse(rawData);
              console.log(
                "getLeadsCalls - JSON parsato con successo senza unescape"
              );
              resolve(resp);
            } catch (thirdError) {
              console.error(
                "Impossibile parsare il JSON anche senza unescape:",
                thirdError
              );
              // Ritorna un array vuoto per evitare il crash dell'applicazione
              resolve([]);
            }
          }
        }
      });

      res.on("error", function(error) {
        console.error("Errore HTTP in getLeadsCalls:", error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
    });

    req.on("error", function(error) {
      console.error("Errore nella richiesta getLeadsCalls:", error);
      reject(error);
    });

    req.write(postData);

    req.end();
  });
}
